import { createReducer } from '@reduxjs/toolkit';

import {
  createSpottedNoteAction,
  setVehicleModal,
  onFilterChange,
  fetchSpottedNotesAction,
  onSearch,
  setLoading,
  editSpottedNoteAction,
  saveAssignedUsersAction,
  updateOneColorInRHLAction,
} from './repo-hit-list-actions';

import { REPO_HIT_LIST_INITIAL_STATE } from './repo-hit-list-constants';

// Give the reducer a stable, named binding for Fast Refresh
const repoHitListReducer = createReducer(REPO_HIT_LIST_INITIAL_STATE, (builder) => {
  builder
    .addCase(setLoading, (state, action) => {
      return { ...state, loading: action.payload };
    })

    // -- create spotted note --
    .addCase(createSpottedNoteAction.pending, (state) => {
      return { ...state, createSpottedNoteLoading: true };
    })
    .addCase(createSpottedNoteAction.fulfilled, (state, action) => {
      return {
        ...state,
        createSpottedNoteLoading: false,
        repoHitList: action.payload.updatedRepoHitList ?? [],
        vehicleModalSpottedNotesData: action.payload.vehicleModalSpottedNotesData,
      };
    })
    .addCase(createSpottedNoteAction.rejected, (state) => {
      return { ...state, createSpottedNoteLoading: false };
    })
    // -- update spotted note --
    .addCase(editSpottedNoteAction.pending, (state) => {
      return { ...state, createSpottedNoteLoading: true };
    })
    .addCase(editSpottedNoteAction.fulfilled, (state, action) => {
      return {
        ...state,
        createSpottedNoteLoading: false,
        repoHitList: action.payload.repoHitList,
        vehicleModalSpottedNotesData:
          action.payload.vehicleModalSpottedNotesData || state.vehicleModalSpottedNotesData,
      };
    })
    .addCase(editSpottedNoteAction.rejected, (state) => {
      return { ...state, createSpottedNoteLoading: false };
    })

    // -- fetch spotted notes --
    .addCase(fetchSpottedNotesAction.pending, (state) => {
      return {
        ...state,
        fetchSpottedNotesLoading: true,
        vehicleModalSpottedNotesData: null,
      };
    })
    .addCase(fetchSpottedNotesAction.fulfilled, (state, action) => {
      return {
        ...state,
        fetchSpottedNotesLoading: false,
        vehicleModalSpottedNotesData: action.payload.spottedNotes ?? [],
      };
    })
    .addCase(fetchSpottedNotesAction.rejected, (state) => {
      return {
        ...state,
        fetchSpottedNotesLoading: false,
        vehicleModalSpottedNotesData: [],
      };
    })
    // -- count total  --
    .addCase(saveAssignedUsersAction.fulfilled, (state, action) => {
      return {
        ...state,
        repoHitList: action.payload.updatedRHL,
        voluntaryCount: action.payload.voluntaryCount || state.voluntaryCount,
        involuntaryCount: action.payload.involuntaryCount || state.involuntaryCount,
        impoundCount: action.payload.impoundCount || state.impoundCount,
        vehicleModalData: action.payload.updatedModal,
      };
    })
    .addCase(saveAssignedUsersAction.rejected, (state) => {
      return { ...state };
    })
    // -- simple actions --
    .addCase(setVehicleModal, (state, action) => {
      return { ...state, vehicleModalData: action.payload };
    })
    .addCase(onSearch, (state, action) => {
      return { ...state, skipAmount: 0, searchQuery: action.payload };
    })
    .addCase(onFilterChange, (state) => {
      return {
        ...REPO_HIT_LIST_INITIAL_STATE,
        loadingOrderTypeCounter: state.loadingOrderTypeCounter,
        allOrderTypeCount: state.allOrderTypeCount,
        voluntaryCount: state.voluntaryCount,
        involuntaryCount: state.involuntaryCount,
        impoundCount: state.impoundCount,
        totalCount: state.totalCount,
        obstructedCount: state.obstructedCount,
        accessibleCount: state.accessibleCount,
      };
    })
    .addCase(updateOneColorInRHLAction.fulfilled, (state, action) => {
      return {
        ...state,
        repoHitList: action.payload.repoHitList,
      };
    })
    // -- default --
    .addDefaultCase((state) => state);
});

// Default export now references a named identifier
export default repoHitListReducer;
// Optional named export for convenience/testing
export { repoHitListReducer };
